export default __webpack_public_path__ + "static/media/s1.dfc3aae8.JPG";